import { Controller } from "@hotwired/stimulus"

// Select all / deselect all checkboxes within the controller scope.
//
// Usage:
//   <div data-controller="select-all">
//     <button data-action="select-all#selectAll">Tout selectionner</button>
//     <button data-action="select-all#deselectAll">Tout deselectionner</button>
//     <input type="checkbox" data-select-all-target="checkbox">
//   </div>
export default class extends Controller {
  static targets = ["checkbox"]

  selectAll() {
    this.checkboxTargets.forEach((cb) => { cb.checked = true })
  }

  deselectAll() {
    this.checkboxTargets.forEach((cb) => { cb.checked = false })
  }
}
